import { gql } from "@apollo/client";

const NearPhotosQuery = gql`
  query nearPhotos($id: Int!) {
    nearPhotos(tid: $id)
  }
`;

const hash = "a04442afe5084ed8bf98562c216e476d77a036f42aa25a067ad8d1ec59fdab12";

export { NearPhotosQuery, hash };
